// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

/**
 * Create a new property
 * @param {*} params
 * @returns
 */
function createPropertyType(params: any): any {
    const baseUrl = `${config.server.api}/v1/property/type`;
    return api.create(`${baseUrl}`, params);
}

/**
 * Update the details of a property
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function updatePropertyType(params: any): any {
    const baseUrl = `${config.server.api}/v1/property/type/${params.id}`;
    return api.updatePatch(`${baseUrl}`, params.data);
}

/**
 * Get a single property
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function getPropertyType(params: any): any {
    const baseUrl = `${config.server.api}/v1/property/type/${params.id}`;
    return api.get(`${baseUrl}`);
}

/**
 * Get propertys for a user
 * @param {*} params
 * @returns
 */
function getPropertyTypes(params: any): any {
    const baseUrl = `${config.server.api}/v1/property/type`;
    return api.get(`${baseUrl}`);
}

export { createPropertyType, updatePropertyType, getPropertyType, getPropertyTypes };
